import { __read } from 'tslib';

var removeEmpty = function (obj) {
    return Object.fromEntries(Object.entries(obj).filter(function (_a) {
        var _b = __read(_a, 2), v = _b[1];
        return v;
    }));
};
var flattenObject = function (obj) {
    var flattened = {};
    Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            Object.assign(flattened, flattenObject(obj[key]));
        }
        else {
            flattened[key] = obj[key];
        }
    });
    return flattened;
};

export { flattenObject, removeEmpty };
//# sourceMappingURL=misc.esm.js.map
